interface InvoicesCounter {
    diff: number;
    error: number;
    ok: number;
    type: string;
    wait: number;
    warn: number;
}

export interface NdsSverkaResult {
    result?: {
        invoices_counters?: InvoicesCounter[];
    };
    error?: string;
}

export interface NdsSverkaParams {
    inn: string;
    kpp?: string;
    periodYear: string;
    periodNumber?: string;
    formattedPeriodNumber: string;
}

export interface INdsPlusApiClient {
    getNdsSverkaPageUrl(params: NdsSverkaParams): string;
    getNdsSverkaStatus(params: NdsSverkaParams): Promise<NdsSverkaResult>;
}
